import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { CircularProgress, Box } from '@mui/material';

/**
 * ProtectedRoute component to guard routes that require authentication
 * If user is not authenticated, redirects to login page with the intended location
 */
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // If still loading auth state, show loading spinner
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // If not authenticated, redirect to login with the current location
  if (!isAuthenticated) {
    // Pass the current location in state so we can redirect back after login
    return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
  }

  // If authenticated, render the protected component
  return children;
};

export default ProtectedRoute;
